import { createFileRoute, Outlet } from '@tanstack/react-router'

/** Area F — Projects & discovery layout: F1 list · F2/F3 detail nest under it. */
export const Route = createFileRoute('/_ws/w/$workspaceId/projects')({
  component: () => <Outlet />,
})
